import { render } from "./EntitiesVerificationPage.vue?vue&type=template&id=7d28f5be"
import script from "./EntitiesVerificationPage.vue?vue&type=script&lang=js"
export * from "./EntitiesVerificationPage.vue?vue&type=script&lang=js"
script.render = render

export default script